import { styled } from '@styles/config'

export const ButtonWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  margin: '16px 0 16px 0',
})
